import { STYLE_OPTIONS } from 'src/constants';
import pageViewStyle from 'src/components/View/Page/pageView.style';

const helpAndInformationStyles = (theme) => ({
  ...pageViewStyle(theme),
  messageForMessageBox: {
    fontFamily: STYLE_OPTIONS.FONT_FAMILY,
    background: 'linear-gradient(135deg, #f8f9ff 0%, #e8ecff 100%)',
    borderRadius: '12px',
    padding: '16px',
    border: '1px solid rgba(102, 126, 234, 0.1)',

    '& .main-content': {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: '20px',

      '@media (max-width: 768px)': {
        gridTemplateColumns: '1fr',
        gap: '16px',
      },
    },

    '& .version-section': {
      backgroundColor: '#fff',
      borderRadius: '8px',
      padding: '16px',
      boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
      border: '1px solid rgba(102, 126, 234, 0.1)',

      '& .version-header': {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '12px',
        marginBottom: '12px',
      },

      '& .version-title': {
        fontSize: '16px',
        fontWeight: 'bold',
        color: STYLE_OPTIONS.COLOR_BLUE,
        marginBottom: '0',
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
      },

      '& .version-badge': {
        backgroundColor: '#667eea',
        color: '#fff',
        padding: '3px 10px',
        borderRadius: '16px',
        fontSize: '11px',
        fontWeight: 'bold',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
      },

      '& .company-info': {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '16px',
        alignItems: 'center',
        fontSize: '13px',
        color: STYLE_OPTIONS.COLOR_GREY_600,

        '& .info-item': {
          display: 'flex',
          alignItems: 'center',
          gap: '6px',

          '& a': {
            ...STYLE_OPTIONS.A_PRIMARY,
            textDecoration: 'none',
            fontWeight: '500',
            fontSize: '13px',

            '&:hover': {
              textDecoration: 'underline',
            },
          },
        },
      },
      '& .mobile-apps-section': {
        marginTop: '12px',
        paddingTop: '12px',
        borderTop: '1px solid rgba(102, 126, 234, 0.1)',

        '& .mobile-apps-header': {
          fontSize: '12px',
          fontWeight: 'bold',
          color: STYLE_OPTIONS.COLOR_BLUE,
          marginBottom: '8px',
          textTransform: 'uppercase',
          letterSpacing: '0.5px',
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
        },

        '& .mobile-apps-links': {
          display: 'flex',
          gap: '12px',
          flexWrap: 'wrap',
        },

        '& .app-store-link': {
          ...STYLE_OPTIONS.A_PRIMARY,
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
          fontSize: '13px',
          fontWeight: '500',
          textDecoration: 'none',
          padding: '6px 12px',
          backgroundColor: 'rgba(102, 126, 234, 0.1)',
          borderRadius: '6px',
          transition: 'all 0.2s ease',

          '&:hover': {
            backgroundColor: 'rgba(102, 126, 234, 0.2)',
            textDecoration: 'none',
          },
        },
      },
      '& .host-app-section': {
        // Same structure as .mobile-apps-section above so the header and
        // buttons line up flush with the CP Chat Mobile App section.
        marginTop: '12px',
        paddingTop: '12px',
        borderTop: '1px solid rgba(102, 126, 234, 0.1)',

        // Differentiate from the blue CP Chat Mobile App section by using the
        // indigo accent of the CP Host App promo bar on the header + buttons.
        '& .host-app-header': {
          fontSize: '12px',
          fontWeight: 'bold',
          color: '#4f46e5',
          marginBottom: '8px',
          textTransform: 'uppercase',
          letterSpacing: '0.5px',
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
        },

        '& .host-app-links': {
          display: 'flex',
          gap: '12px',
          flexWrap: 'wrap',
        },

        // Match the base .app-store-link sizing (padding/font) from the
        // CP Chat Mobile App section so buttons are identical in size;
        // recolored to indigo to differentiate.
        '& .app-store-link': {
          ...STYLE_OPTIONS.A_PRIMARY,
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
          fontSize: '13px',
          fontWeight: '500',
          textDecoration: 'none',
          padding: '6px 12px',
          borderRadius: '6px',
          transition: 'all 0.2s ease',
          color: '#4f46e5',
          backgroundColor: 'rgba(99, 102, 241, 0.15)',

          '&:hover': {
            backgroundColor: 'rgba(99, 102, 241, 0.28)',
            textDecoration: 'none',
          },
        },

        // Shareable /host link row that salespeople send to their hosts.
        '& .host-share-label': {
          marginTop: '10px',
          fontSize: '11px',
          fontWeight: '600',
          color: STYLE_OPTIONS.COLOR_TEXT,
        },

        '& .host-share-row': {
          marginTop: '6px',
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
          flexWrap: 'wrap',
          padding: '4px 4px 4px 10px',
          backgroundColor: '#fff',
          border: '1px solid rgba(99, 102, 241, 0.25)',
          borderRadius: '6px',
        },

        '& .host-share-url': {
          flex: '1 1 auto',
          minWidth: '160px',
          fontSize: '12px',
          color: STYLE_OPTIONS.COLOR_TEXT,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        },

        '& .host-share-btn': {
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
          flex: '0 0 auto',
          fontSize: '12px',
          fontWeight: '600',
          padding: '5px 10px',
          backgroundColor: '#4f46e5',
          color: '#fff',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          transition: 'all 0.2s ease',
          whiteSpace: 'nowrap',

          '&:hover': {
            backgroundColor: '#4338CA',
          },
        },
      },
      '& .whats-new-section': {
        marginTop: '12px',
        paddingTop: '12px',
        borderTop: '1px solid rgba(102, 126, 234, 0.1)',

        '& .whats-new-header': {
          fontSize: '12px',
          fontWeight: 'bold',
          color: '#5850EC',
          marginBottom: '8px',
          textTransform: 'uppercase',
          letterSpacing: '0.5px',
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
        },

        '& .whats-new-item': {
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '4px 0',

          '& .whats-new-text': {
            fontSize: '12px',
            fontWeight: '500',
            color: STYLE_OPTIONS.COLOR_TEXT,
          },

          '& .whats-new-link': {
            fontSize: '11px',
            textDecoration: 'none',
            fontWeight: '600',
            padding: '4px 10px',
            backgroundColor: '#5850EC',
            color: '#fff',
            borderRadius: '4px',
            border: 'none',
            cursor: 'pointer',
            whiteSpace: 'nowrap',

            '&:hover': {
              backgroundColor: '#4338CA',
              textDecoration: 'none',
            },
          },
        },
      },
    },

    '& .support-section': {
      backgroundColor: '#fff',
      borderRadius: '8px',
      padding: '16px',
      boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
      border: '1px solid rgba(102, 126, 234, 0.1)',

      '& .support-header': {
        fontSize: '16px',
        fontWeight: 'bold',
        color: STYLE_OPTIONS.COLOR_BLUE,
        marginBottom: '12px',
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
      },

      '& .support-grid': {
        display: 'flex',
        gap: '12px',
        marginBottom: '12px',

        '@media (max-width: 480px)': {
          flexDirection: 'column',
          gap: '8px',
        },
      },

      '& .support-item': {
        flex: 1,
        padding: '10px',
        backgroundColor: 'rgba(102, 126, 234, 0.05)',
        borderRadius: '6px',
        border: '1px solid rgba(102, 126, 234, 0.1)',

        '& .support-label': {
          fontSize: '11px',
          fontWeight: 'bold',
          color: STYLE_OPTIONS.COLOR_BLUE,
          marginBottom: '4px',
          textTransform: 'uppercase',
          letterSpacing: '0.5px',
        },

        '& .support-content': {
          fontSize: '13px',
          color: STYLE_OPTIONS.COLOR_TEXT,
          lineHeight: '1.3',

          '& a': {
            ...STYLE_OPTIONS.A_PRIMARY,
            textDecoration: 'none',
            fontWeight: '500',
            fontSize: '13px',

            '&:hover': {
              textDecoration: 'underline',
            },
          },

          '& .phone-number': {
            fontWeight: 'bold',
            color: STYLE_OPTIONS.COLOR_BLUE,
          },
        },
      },

      '& .classes-section': {
        padding: '12px',
        backgroundColor: 'rgba(255, 193, 7, 0.1)',
        borderRadius: '6px',
        border: '1px solid rgba(255, 193, 7, 0.2)',

        '& .classes-header': {
          fontSize: '12px',
          fontWeight: 'bold',
          color: '#e67e22',
          marginBottom: '8px',
          textTransform: 'uppercase',
          letterSpacing: '0.5px',
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
        },

        '& .class-item': {
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '4px 0',
          borderBottom: '1px solid rgba(255, 193, 7, 0.1)',

          '&:last-child': {
            borderBottom: 'none',
          },

          '& .class-name': {
            fontSize: '12px',
            fontWeight: '500',
            color: STYLE_OPTIONS.COLOR_TEXT,
          },

          '& .class-link': {
            ...STYLE_OPTIONS.A_PRIMARY,
            fontSize: '11px',
            textDecoration: 'none',
            fontWeight: '500',
            padding: '3px 8px',
            backgroundColor: 'rgba(102, 126, 234, 0.1)',
            borderRadius: '4px',

            '&:hover': {
              backgroundColor: 'rgba(102, 126, 234, 0.2)',
              textDecoration: 'none',
            },
          },
        },
      },

      '& .guides-section': {
        padding: '12px',
        backgroundColor: 'rgba(76, 175, 80, 0.1)',
        borderRadius: '6px',
        border: '1px solid rgba(76, 175, 80, 0.2)',

        '& .guides-header': {
          fontSize: '12px',
          fontWeight: 'bold',
          color: '#388e3c',
          marginBottom: '8px',
          textTransform: 'uppercase',
          letterSpacing: '0.5px',
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
        },

        '& .guide-item': {
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '4px 0',
          borderBottom: '1px solid rgba(76, 175, 80, 0.1)',

          '&:last-child': {
            borderBottom: 'none',
          },

          '& .guide-name': {
            fontSize: '12px',
            fontWeight: '500',
            color: STYLE_OPTIONS.COLOR_TEXT,
          },

          '& .guide-link': {
            ...STYLE_OPTIONS.A_PRIMARY,
            fontSize: '11px',
            textDecoration: 'none',
            fontWeight: '500',
            padding: '3px 8px',
            backgroundColor: 'rgba(76, 175, 80, 0.15)',
            borderRadius: '4px',
            border: 'none',
            cursor: 'pointer',

            '&:hover': {
              backgroundColor: 'rgba(76, 175, 80, 0.25)',
              textDecoration: 'none',
            },
          },
        },
      },
    },

    // Legacy styles for backward compatibility
    '& .inner-message': {
      display: 'none', // Hide old styling
    },

    '& .support-facebook': {
      display: 'none', // Hide old styling
    },
  },
});

export default helpAndInformationStyles;
